import {redirect} from "react-router-dom";
import Products from "../../../services/UkTreatmentApi/Products";

export async function action({params}) {
    await Products.delete(params.productId);

    return redirect("/manage/products");
}